import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { UAParser } from "ua-parser-js";
import { v4 as uuidv4 } from "uuid";
import { setDeviceInfo } from "../redux/slices/auth/deviceSlice";

const useDeviceTracker = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const alreadyTracked = localStorage.getItem("deviceTracked");
    if (alreadyTracked) {
      // Optional: load from storage on refresh
      const cached = localStorage.getItem("deviceInfo");
      if (cached) {
        dispatch(setDeviceInfo(JSON.parse(cached)));
      }
      return;
    }

    const parser = new UAParser();
    const device = parser.getDevice();
    const os = parser.getOS();
    const browser = parser.getBrowser();

    const deviceName = device.model || "Unknown";
    const deviceType = device.type || "desktop";
    const osName = os.name || "Unknown";
    const browserName = browser.name || "Unknown";
    const browserVersion = browser.version || "Unknown";

    let deviceId = localStorage.getItem("deviceUniqueId");
    if (!deviceId) {
      deviceId = uuidv4();
      localStorage.setItem("deviceUniqueId", deviceId);
    }

    const appVersion = process.env.REACT_APP_VERSION || "1.0.0";

    const baseInfo = {
      deviceType,
      deviceName,
      osName,
      browserName,
      browserVersion,
      userAgent: navigator.userAgent,
      deviceUniqueId: deviceId,
      appVersion,
    };

    // Fetch IP and only then dispatch
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        const fullInfo = {
          ...baseInfo,
          ipAddress: data.ip,
        };

        console.log("📱 Device Info Collected:", fullInfo);

        dispatch(setDeviceInfo(fullInfo));
        localStorage.setItem("deviceInfo", JSON.stringify(fullInfo));
        localStorage.setItem("deviceTracked", "true");
      })
      .catch((err) => {
        console.error("Failed to fetch IP or track device", err);
      });
  }, [dispatch]);
};

export default useDeviceTracker;
